import { React, useState, useContext } from 'react'
import { MyContextProvider } from "../../../../App";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {getFormattedDate,isEndDateGreater,changeDateFormat,getMonthsBetween} from '../../../../Custom/Custom'
import { GlobalLoading, showLoading } from 'react-global-loading';
import axios from 'axios';
import { API_URL, getAuthHeaders, getUserClaimsForUi } from '../../../../Constant';
import messages from '../../../../assets/Messages.json';
import { ToastContainer, toast } from 'react-toastify';
import  {MonthlyWholeSaleIndexItemwiseExcelData}  from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import priceTitle from '../../../../price.json';

function MonthlyWholeSaleIndexItemwiseReport() {

    const token = useContext(MyContextProvider).token;
    const decode_token = getUserClaimsForUi();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const storedLanguage = localStorage.getItem('language');
    const today = new Date();
    const config = getAuthHeaders();



const mergeData = (data,type) => {
    return data.reduce((acc, item, index) => {
        if(type==='group'){
            acc[`controlPrice${index + 1}`] = '';
        }else{
          acc[`controlPrice${index + 1}`] = formatGrossValue(item.controlPrice);
        }
        acc[`controlPriceAvg${index + 1}`] = formatGrossValue(item.controlPriceAvg);
        return acc;
    }, {});
    };


    //merge control abd Avg Price Data 
const controlData=(columnData,type)=>{
    let finalArray=mergeData(columnData,type);
    return finalArray
}


//Convert Roman Digit
  const convertToRoman = (num) => {
    const romanNumerals = [
        { value: 1000, numeral: 'M' },
        { value: 900, numeral: 'CM' },
        { value: 500, numeral: 'D' },
        { value: 400, numeral: 'CD' },
        { value: 100, numeral: 'C' },
        { value: 90, numeral: 'XC' },
        { value: 50, numeral: 'L' },
        { value: 40, numeral: 'XL' },
        { value: 10, numeral: 'X' },
        { value: 9, numeral: 'IX' },
        { value: 5, numeral: 'V' },
        { value: 4, numeral: 'IV' },
        { value: 1, numeral: 'I' },
    ];

    let result = '';
    for (const { value, numeral } of romanNumerals) {
        while (num >= value) {
            result += numeral;
            num -= value;
        }
    }
    return result;
};

   
   
//handle excel sheet ***************
const handleGenerateExcel = async() => {

      if(!isEndDateGreater(startDate,endDate)){
          toast.error(messages.DATE_BETWEEN_MESSAGE, messages.COLOR_RED);
          return;
        }

        let sDate= getFormattedDate(startDate);
        let eDate=  getFormattedDate(endDate);

    try {
    showLoading(true);

        let post_data={
            fromDate: sDate,
            toDate:eDate
        }

        const response = await axios.post(`${API_URL}api/price/MonthlyWholeSaleIndexItemwiseReport`, post_data, config);
        const reportData = response.data;
       if(reportData.status){
        let allData= reportData.data[0].GroupCodes;
       const alldataName=[]
        const mappedData = [];
        allData.forEach(group => {
            // Add group data
            alldataName.push(group.majorGroupName)
                 mappedData.push({
                     type: 'group',
                      name: group.majorGroupName,
                      unit: '',
                      baseYearPrice:'',
                      ...controlData(group.granddatesdataavg,'group')
                    });
           group.subgroupsdata.forEach(subgroup => {
                mappedData.push({
                    type: 'subGroup',
                    name: subgroup.itemNamewithDistrict,
                    unit: subgroup.unit,
                    baseYearPrice:subgroup.baseYearPrice ,
                    ...controlData(subgroup.alldatesdata,'subGroup')
               });

            })
            

        });

    downloadReport(mappedData,sDate,eDate)

        }else{
          toast.error('Data is not found', messages.COLOR_RED);
        }
      
   } catch (error) {
    console.error(error);

    }finally{
    showLoading(false);
    }
   }


const formatGrossValue = (value) => {
    if (value === 0) return '0.00';
    if (value === "NaN" ) return '';
    if (value === '' || value === null) return '';
    return Number(value).toFixed(2);
};
   

const createAlternateArray = (data) => {
    const result = [];
    data.forEach((item, index) => {
      result.push(item); 
      result.push(`Control Price`); 
    });
    return result;
  };
  
   
  const controlItemAndAvg = (item, len) => {

    const result = [];
    for (let i = 1; i <= len; i++) {
        result.push(item[`controlPrice${i}`]);
        result.push(item[`controlPriceAvg${i}`]);
    }
   return result;
};
   
const numberToLetter = (num) => {
    const mapping = {
      1: 'A',
      2: 'B',
      3: 'C',
      4: 'D',
      5: 'E',
      6: 'F',
      7: 'G',
      8: 'H',
      9: 'I',
      10: 'J',
      11: 'K',
      12: 'J',
      13: 'M',
 };
    return mapping[num] || null; 
  };



const downloadReport=(mappedData,sDate,eDate)=>{

  let yearColumn= getMonthsBetween(sDate,eDate,'Control Average Price');
  let column=createAlternateArray(yearColumn)
  let srNo=0;
  let roman=0
  const transformedData = mappedData.map((item ,index)=>{
      if(item.type==='group'){
        roman=0
      }

      return [
     (item.type==='group')? ++srNo: convertToRoman(++roman),
      item.name,
      item.unit,
      formatGrossValue(item.baseYearPrice),
       ...controlItemAndAvg(item,yearColumn.length)
     
      ]

   })
let headerEnglishColumns=['Sr.No','Item Name','Unit','Base Year Price',
    ...column
]


let excelObjectData = {
        fileName:`MonthlyWholeSaleIndexItemwiseReport(${sDate.replace(/ /g, "_")}-${eDate.replace(/ /g, "_")})`,
        fileType:'xls',
        sheetName: 'WholeSaleIndexItemWise',
        firstRowMergeCells: (headerEnglishColumns.length<=16)? 
        `A1:${numberToLetter(headerEnglishColumns.length)}1`:
        'A1:M1',//'A1:F1',
        firstRowExportDate:  changeDateFormat(new Date()),
        secondRowMergeCells: (headerEnglishColumns.length<=16)? 
        `A2:${numberToLetter(headerEnglishColumns.length)}2`:
        'A2:M2',
        secondRowText: `Monthly WholeSale Index Itemwise Report (${sDate}-${eDate})`,
        headerEnglishColumns:headerEnglishColumns,
        boldColumn:["Rice","Wheat","Barley","Jowar","Bajra","Maize","Arhar","Urd","Moong","Masoor","Peas",
            "Gram","Soyabean","Banana","Apple","Dry Fruits","Litchi","Papaya","Mango","Grapes","Brinjal",
            "Cabbage/Cauliflower","Onion","Tomato","Sweet Potato","Potato","Green Peas","Lobia","Milk","Curd",
            "Meat","Egg","Fish","Coriander","Turmeric","Chillies","Ginger(dry)","Cotton Yarn & Fibre",
            "Jute (raw)","Wool","Ground nut","Ragi & Mustard","Castor Seed","Dhaincha Seed","Lineseed",
            "Mahuwa Seed","Methi Seed","Sun Flower Seed","Hides (raw)","Bone (crushed)","Skin (raw)",
            "Sugarcane","Timber and Logs","Tobacco(raw)","Bhusa","Silica","Lime","Stone Chip","Minor Minerals (Sand)","Coal and Coke","Kerosene Oil","Petrol","Diesel Oil","L.P.G. Cylinder","Electricity","Non Conventional Electricity (Solar Energy)","Lubricating oil","Furnace Oil","Powder Milk","Ghee","Butter","Khoya","Paneer","Cream","Ice Cream Powder","Tea","Coffee","Canned Juice","Jam Mixed","Food Products","Tomato Ketchup","Maida","Atta","Besan","Suji","Bhusi","Chuni  Arhar","Choker","Biscuit","Bakery Products","Bread","Custard Powder","Sugar","Khandsari","Gur","Sweetmeat Confectionary (Toffees)","Vanaspati","Mustard Oil","Coconut Oil","Oil Soyabeans (Refined)","Oil and Rice Bran","Mustard Cake","Glucose ( Non Chemical Variety)","Molasses","Salt","Kaththa","Alcohol/Liquor (IMFL)   Blended","Toddy","Liquor Country","Beer","Liquor","Rectified Spirit","Soft Drink (Pepsi)","Cigarettes","Bidi","Pan","Other Tobbaco Products","Yarn","Cotton Cloth Knitted","Cotton Yarn","Furnishing Cloth (Mattress)","Khadi Cloth","Trousers or Pants  Cotton","Cloth finished /processed and cotton (Dhoti and Laththa)","Garment cloth  cloth  (Shirt)","Tent cloth","Umbrella","Sarees  cotton staple fibre","Bed sheet  cotton","Cotton hosiery","Yarn of wool / animal hair  KDR","Coats/ Overcoats","Woolen Cloth & Khadi","Zari - saree","Khadi Kurta","Khadi","Silk and Artificial Silk Clothes","Nylon /terrene mixed cloth pant","Rags","Carpets wollen","Gunny Bags","Plywood and particle board","Firewood","Handicraft (Wooden stick)","Wooden cases","Furniture","Paper (Writing)","Paper (Printing)","Paper (Printing Paper)","Fountain pen and pencil","Printed materials","Carbon black","Exercise books","Leather goods","Footwear","Tyre and tube","Plastic Granuales","Thermocol product","Foam  laminated","Colled Rolled Sheets","Phenolic laminates","Sport goods","Plastic Goods","Box plastic","Sports Goods","Rubber and plastic shoes","Tanning chemical","Acrylonitrite","Polymers","Calcium Carbonate","Agricultural chemicals etc. for growth protection","Fertilizers","Nitrogenous Urea (NPK)","Phosphetic (Super Phospetic)","Other basic items (Pesticides)","Insecticides","Malathian","Paints and Varnish","Drugs & Medicines","Dental and Dentistry materials","Chyavanprash","Multi Vitamins","Ayurvedic medicines","Unani medicines","Menthol","Homeopathetic and bio chemic medicines","Antibiotics and preparations","Oxygen Liquid","Blood Pressure Machines","Vaccine for polio","Soap","Wax Candles","Agarbattis","Detergent Cake","Essential Oil","Cyano Pyridine","Matches","Structural Products and Sanitory Fittings","Bricks","Flour mill stone","Tiles","Glassware  Pressed","Chimney","Sculpture","Bangles","Bottles and Jar","Earthern Pottery Crockery Set","Pressure Cooker (United)","Utensils  Stainless Steel","Cement","Asbestos Cement based article","Iron and Steel & Ferrous Alloys","Sacks  HDPE woven (Folding bed)","Steel Ingots","Iron Pipes","Wire  Alluminium","Hair Pins","Clips  Non Ferrous","Aluminium Ingots","Metal Products","Drum  Musical","Engineering Levels (Biological Box)","Refraction","Materials Handling Equipment","Castings and Forging  Iron / Steel","Fabricated Metal Products","Fabrication and Welding Rods","Gas Appliances","Locks","Brass Casting","Grill Gate","Jewellery  Silver","Stone  Precious","Gold Coin","Ornaments and Jewellery","Pearls","Polypropypylene Monofilament (Plastic Rassi)","Rings Steel","Bolts and Nuts","Sheets and Plates Iron and Steel","Almirah  Steel","Chair  Metal","Machine Tools and Accessories","Oil Mill Machinery","Lathe Works (Drilling Machine)","Cultivators","Agricultural Machinery","Crankshafts Motorsysle","Airconditioner","Washing Machines","Watches and Clocks","Pumps  Injection","Rice Mill Machinery","Xerox  /Photocopier / Reprographic Machine","Generators (SriRam Honda)","Vacuum Cleaner","Electric Motor (Tullu Pump)","Insulation Board and Electric Board(Heavells)","Transformer 35 K.V.A.","Transformer","Dry Cell","Telescope","Electric Lamp","Picture Tube","Video Photography(Video Camera)","Photography Digital Camera","Mobile","Conductor A.C.S.R (Heavells)","Electric Fan (Ceiling)","Television Set","Flash Light Case","Electrical Equipment and parts(","Transistor","Motor Vehicles","Car","Motor Vehicles Tractor Parts","Motor Vehicles Parts","Diesel Engine","Cart Animal Driven","Scooters","Motorcycles","Motorcycles Parts","Magnets","Bicycles"],

       excelRowData:transformedData,
      };

  MonthlyWholeSaleIndexItemwiseExcelData(excelObjectData);
    }


     return (
       <>
           <ToastContainer />
           <GlobalLoading />
           <div className="container-fluid py-3">
               <div className="card mx-3 mb-3">
                   <div className="card-body pb-1">
                       <div className="row align-items-center">
                           <h4 className="page_heading">
                               <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? priceTitle.hi.MON_WHOLE_SALE_INDEX_ITEM_WISE_REPORT : priceTitle.en.MON_WHOLE_SALE_INDEX_ITEM_WISE_REPORT }} />
                           </h4>
                           <div className="row align-items-center">
                           
                           
                           <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">From Date</label>
                                    <DatePicker
                                        className="form-control calendar_icon"
                                        selected={startDate}
                                        onChange={(e) => { setStartDate(e) }}
                                        dateFormat="MMM yyyy"
                                        showMonthYearPicker
                                        placeholderText="Select month"
                                        maxDate={today}
                                    />
                                </div>
   
   
                           <div className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3">
                                    <label className="fw-bold h6">To Date</label>
                                    <DatePicker
                                        className="form-control calendar_icon"
                                        selected={endDate}
                                        onChange={(e) => { setEndDate(e) }}
                                        dateFormat="MMM yyyy"
                                        showMonthYearPicker
                                        placeholderText="Select month"
                                        maxDate={today}
                                    />
                                </div>
   
   
                           <div className="col-xl-2 col-lg-4 mb-3">
                               <label className="w-100 d-none d-sm-block">&nbsp;</label>
                               <button onClick={handleGenerateExcel} className="btn btn_orange">Get Report</button>
                           </div>
                           </div>
   
   
                       </div>
                   </div>
               </div>
           </div>
      </>
     )
   }

export default MonthlyWholeSaleIndexItemwiseReport